(() => {
    document.addEventListener('ProductBox_AddToCart', (e) => {
        const addToCartDatasetId = 'gtm-add-to-cart';
        const addToCartDataset = document.getElementById(addToCartDatasetId);
        const addToCart = JSON.parse(addToCartDataset.dataset.gtmJson);

        const itemDatasetId = `gtm-cart-item-${e.detail.variantCode}`;
        const itemDataset = document.getElementById(itemDatasetId);
        const item = JSON.parse(itemDataset.dataset.gtmJson);

        item.quantity = e.detail.quantity;
        addToCart.ecommerce.items.push(item);

        window.dataLayerPushDeferred({ ecommerce: null });
        window.dataLayerPushDeferred(addToCart);
    });
})();
